import MLLModal from './MLLModal';

export default MLLModal;
